import { jsx } from 'react/jsx-runtime';
import React__default, { forwardRef, Fragment } from 'react';
import * as Headlessui from '@headlessui/react';
import classNames from 'classnames';

const MenuOptions = /*#__PURE__*/ forwardRef(({ className, position = 'bottom', anchorPosition = 'right', children }, ref)=>{
    const items = Array.isArray(children) ? children.filter((c)=>/*#__PURE__*/ React__default.isValidElement(c)) : /*#__PURE__*/ React__default.isValidElement(children) && children;
    return jsx(Headlessui.Transition, {
        as: Fragment,
        enter: "transition ease-out duration-100",
        enterFrom: "transform opacity-0 scale-95",
        enterTo: "transform opacity-100 scale-100",
        leave: "transition ease-in duration-75",
        leaveFrom: "transform opacity-100 scale-100",
        leaveTo: "transform opacity-0 scale-95",
        children: jsx(Headlessui.Menu.Items, {
            ref: ref,
            as: "menu",
            className: classNames(`cb-menu-options ${position}`, anchorPosition, className),
            static: true,
            children: jsx("div", {
                className: "container",
                children: items
            })
        })
    });
});
MenuOptions.displayName = 'Menu.Options';

export { MenuOptions };
//# sourceMappingURL=Menu.Options.es.js.map
